// Import dependencies
import React, {Component} from 'react';

// Import components
import {ParagraphText} from "../UXLibrary";

// Import css
import './SoundButton.css';

// Import images
import sound from '../../../resources/icons/sound.png'

export default class SoundButton extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            active: true
        };
        this.toggleSound = this.toggleSound.bind(this);
    }

    toggleSound()
    {
        if (this.state.active) {
            this.setState({ active: false });
            this.props.toggleSound()
        }
        else {
            this.setState({ active: true });
            this.props.toggleSound()
        }
    }

    render() {
        return (
            <div className='sb__container'>
                {
                    this.props.width > 770 ?
                        <ParagraphText>
                            SOUND
                        </ParagraphText>
                        :
                        null
                }
                <div className='sb__wave-container' onClick={this.toggleSound}>
                    <img
                        src={sound}
                        className={ this.state.active ? 'sb__wave-image sb-active' : 'sb__wave-image' }
                        alt='sound-wave'
                    />
                </div>
            </div>
        );
    }
}
